import axios from "@/app/plugins/Axios";
import qs from "qs";
import { parseParams } from "../helpers/utils";

export default new (class PedidosService {
  listar(parametros) {
    return axios
      .get("pedidos?" + qs.stringify(parametros))
      .then((response) => response.data);
  }

  abrir(pedido_id) {
    return axios.get("/pedidos/" + pedido_id).then((response) => response.data);
  }

  copiar(pedido_id) {
    return axios
      .get("/pedidos/" + pedido_id + "/copiar")
      .then((response) => response.data);
  }

  salvar(pedido) {
    return axios.post("/pedidos", pedido).then((response) => response.data);
  }

  finalizar(pedido) {
    return axios.post(`/pedidos/${pedido.id}/finalizar`, pedido).then((response) => response.data);
  }

  atualizar(pedido) {
    return axios
      .put("/pedidos/" + pedido.id, pedido)
      .then((response) => response.data);
  }

  excluir(pedido_id) {
    return axios
      .delete("/pedidos/" + pedido_id)
      .then((response) => response.data);
  }

  atualizarestoque(produto) {
    return axios
      .post("/pedidos/atualizarestoque", produto)
      .then((response) => response.data);
  }

  adicionaritem(dados) {
    return axios
      .post(`/pedidos/${dados.pedido_id}/adicionaritem`, dados.produto)
      .then((response) => response.data);
  }

  removeritem(dados) {
    return axios
      .post("/pedidos/removeritem", dados)
      .then((response) => response.data);
  }

  faturar(post) {
    return axios
      .post("/pedidos/faturar", post)
      .then((response) => response.data);
  }

  faturas(pedido_id) {
    return axios
      .get("/pedidos/" + pedido_id + "/faturas")
      .then((response) => response.data);
  }

  estornar(pedido_id) {
    return axios
      .post("/pedidos/estornar/" + pedido_id)
      .then((response) => response.data);
  }

  impressaoTermica(pedido_id) {
    return axios
      .post(`pedidos/${pedido_id}/imprimir`)
      .then((response) => response.data);
  }

  vendasdiarias(filtro) {
    filtro = parseParams(filtro);
    return axios
      .get(`pedidos/relatorios/vendasdiarias`, { params: filtro })
      .then((response) => response.data);
  }
})();
